import { render, staticRenderFns } from "./ModalMedicinePayment.vue?vue&type=template&id=72ad436a"
import script from "./ModalMedicinePayment.vue?vue&type=script&lang=js"
export * from "./ModalMedicinePayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports